// Main component that combines all parts
import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import DiscussionDetailsSection from './Components/DiscussionDetail';
import DiscussionLeftPanel from './Components/DiscussionLeftPanel';
import DiscussionRightPanel from './Components/DiscussionRightPanel';
import NewDiscussionDialog from './Components/NewDiscussionDialog';
import {
  DiscussionItem,
  DiscussionDetails,
  DiscussionReply
} from './types';
import dayjs from 'dayjs';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100vh - 150px)',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
  },
  mainSection: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    gap: '10px',
    padding: '0 0.25rem',
  },
}));

const FacultyPortalDiscussion: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const id = location?.state?.forumId;

  const [tabValue, setTabValue] = useState(0);
  const [discussions, setDiscussions] = useState<DiscussionItem[]>([]);
  const [favoriteDiscussions, setFavoriteDiscussions] = useState<DiscussionItem[]>([]);
  const [currentDiscussionReplies, setCurrentDiscussionReplies] = useState<DiscussionReply[]>([]);
  const [discussionDetails, setDiscussionDetails] = useState<DiscussionDetails>({
    createdBy: 'Ashishkumar Jerambhai Tandel',
    createdOn: '31 Jan 2025',
    subject: 'Admin portal discussion',
    totalReplies: 0,
    lastPostOn: '31 Jan 2025',
  });
  const [openNewDiscussionDialog, setOpenNewDiscussionDialog] = useState(false);
  const [discussionId, setDiscussionId] = useState<string | null>(null);
  const [replyText, setReplyText] = useState('');
  const [selectedDiscussionId, setSelectedDiscussionId] = useState<string | null>(null);
  const [selectedDiscussion, setSelectedDiscussion] = useState<any | undefined>(undefined);


  const handleTabChange = (newValue: number) => {
    setTabValue(newValue);
  };

  const handleDiscussionClick = (id: string, discussionId: string, discussionData?: any) => {
    setSelectedDiscussion(id);
    setSelectedDiscussionId(id);
    setDiscussionId(discussionId);

    if (discussionData) {
      // Update discussion details based on the selected discussion
      setDiscussionDetails({
        createdBy: discussionData.userfullname || 'Unknown',
        createdOn: dayjs.unix(discussionData.created).format("DD MMM YYYY") || 'Unknown',
        subject: discussionData.subject || 'Unknown',
        totalReplies: discussionData.totalReplies || 0,
        lastPostOn: dayjs.unix(discussionData.timemodified).format("DD MMM YYYY") || 'Unknown',
      });
    }
  };

  const handleOpenNewDiscussionDialog = () => {
    setOpenNewDiscussionDialog(true);
  };

  const handleCloseNewDiscussionDialog = () => {
    setOpenNewDiscussionDialog(false);
  };

  const handleReplyTextChange = (text: string) => {
    setReplyText(text);
  };

  const handleSubmitReply = () => {
    // Here you would call an API to submit the reply
    console.log('Submitting reply:', replyText);
    setReplyText('');
  };
  const handleNewDiscussion = () => {
    // Implement functionality for creating a new discussion
    console.log("Creating new discussion");
  };

  const getCurrentDiscussion = () => {
    const allDiscussions = [...discussions, ...favoriteDiscussions];
    return allDiscussions.find(d => d.id === selectedDiscussion);
  };

  const getFilteredDiscussions = () => {
    return tabValue === 0 ? discussions : favoriteDiscussions;
  };
  const [dialogOpen, setDialogOpen] = useState(false);

  // Function to handle dialog open
  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  // Function to handle dialog close
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  // Function to handle successful submission
  const handleSuccessfulSubmission = () => {
    console.log('Discussion created successfully');
    // You can refresh your discussions list here
    // For example: fetchDiscussions();
  };
  const handlePostCountChange = (count: number) => {
    setDiscussionDetails(prevDetails => ({
      ...prevDetails,
      totalReplies: count
    }));
  };

  return (
    <Box className={classes.root}>
      {/* Discussion details section */}
      {discussionDetails && (
        <DiscussionDetailsSection details={discussionDetails}  onPostCountChange={handlePostCountChange} />
      )}
      {/* Main section with left and right panels */}
      <Box className={classes.mainSection}>
        {/* Left panel - Discussions list */}
        <DiscussionLeftPanel
          tabValue={tabValue}
          onTabChange={handleTabChange}
          // discussions={getFilteredDiscussions()}
          selectedDiscussion={selectedDiscussion}
          onDiscussionClick={handleDiscussionClick}
          allCount={discussions.length}
          favoriteCount={favoriteDiscussions.length}
          forumId={id}

        />

        {/* Right panel - Discussion content */}
        <DiscussionRightPanel
          selectedDiscussion={getCurrentDiscussion()}
          selectedDiscussionId={selectedDiscussionId}
          discussionId={discussionId}
          onNewDiscussion={handleOpenNewDiscussionDialog}
          replyText={replyText}
          onReplyTextChange={handleReplyTextChange}
          onSubmitReply={handleSubmitReply}
          forumId={id}
          onPostCountChange={handlePostCountChange}
        />
      </Box>

      {/* New Discussion Dialog */}
      <NewDiscussionDialog
        open={openNewDiscussionDialog}
        // onClose={handleCloseDialog}
        forumId={id}
        onSuccess={handleSuccessfulSubmission}
        onClose={handleCloseNewDiscussionDialog}
      />
    </Box>
  );
};

export default FacultyPortalDiscussion;